import axios from "axios";
export const postEmployeePermission = async (values: any) => {
  return axios({
    baseURL: process.env.REACT_APP_BASE_URL,
    method: "PUT",
    url: `/authentication/user-groups`,
    data: values,
  });
};
